import script from "./CommonShapeAnimation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonShapeAnimation.vue?vue&type=script&setup=true&lang=ts"

import "./CommonShapeAnimation.vue?vue&type=style&index=0&id=114a8301&lang=sass"

const __exports__ = script;

export default __exports__